// Generated by CoffeeScript 2.7.0
var PushPackageGenerator, push_entry_comp;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

push_entry_comp = {
  props: {
    index: {
      type: [String, Number],
      default: 1
    },
    push: {
      type: Object,
      required: true,
      default: function() {
        return {
          push_type: 'Push::CustomMessage',
          waiting: 60,
          interval: 0,
          recipient_types: ['unread']
        };
      }
    },
    periodic: {
      type: Boolean,
      default: false
    },
    availableTypes: {
      type: Array,
      default: function() {
        return [
          {
            options: ["Push::CustomMessage",
          'Push::Sms',
          'Push::Call']
          }
        ];
      }
    }
  },
  components: {
    dropdown: DropdownSelect
  },
  data: function() {
    return {
      push_entry: this.push,
      expanded: true,
      human_hour: parseInt(this.push.waiting / 60),
      human_minute: this.push.waiting % 60
    };
  },
  template: `<div class="push-item phase-item" :class="{ expanded: expanded }">
  <div class="phase-header">
    <div class="phase-indexer circle-index">
      <span>{{ index }}</span>
    </div>
    <div class="phase-name">步骤{{ index }}</div>
  </div>
  <div class="phase-content">
    <div class="push-summary" v-if='!expanded' @click='expand'>
      <span>系统将{{ index === 1 ? '' : '在上一次推送结束' }}</span>
      <strong>{{ human_time }}</strong>
      <span>对内容进行</span>
      <strong>{{ _typeText(push_entry.push_type) }}</strong>
      <span>推送</span>
      <span v-if='push_entry.recipient_types.length'>
        <span>(范围：</span>
        <span class="chips">
          <span class="chip" v-for='recipient_type in push_entry.recipient_types'>全部{{ _recipentTypeText(recipient_type) }}</span>
        </span>
        <span>)</span>
      </span>
    </div>
    <div class="phase-branches" v-show='expanded'>
      <div class="branch-item">
        <div class="branch-header">
          <span>推送时间</span>
        </div>
        <div class="branch-content">
          <label class="input-chip">
            <input type="number" placeholder='请输入' v-model='human_hour' />
            <span>小时</span>
          </label>
          <label class="input-chip">
            <input type="number" placeholder='请输入' v-model='human_minute' />
            <span>分钟</span>
          </label>
        </div>
      </div>
      <div class="branch-item">
        <div class="branch-header">
          <span>推送类型</span>
        </div>
        <div class="branch-content">
          <dropdown :optionGroups='availableTypes'
                    :initValue='push_entry.push_type'
                    @change='updatePushType'>
            <template slot='value-template' slot-scope='{ option }'>{{ _typeText(option) }}</template>
            <template slot='option-template' slot-scope='{ option }'>{{ _typeText(option) }}</template>
          </dropdown>
        </div>
      </div>
      <div class="branch-item">
        <div class="branch-header">
          <span>推送范围</span>
        </div>
        <div class="branch-content">
          <div class="options inline">
            <label class="option-item">
              <input type="checkbox" hidden='true' :checked="_checkRecipient('unread')" @change='toggleUnreadRecipient' />
              <i class="slp-square-o"></i>
              <span class="option-label">全部{{ _recipentTypeText('unread') }}</span>
            </label>
            <label class="option-item">
              <input type="checkbox" hidden='true' :checked="_checkRecipient('uncompleted')" @change='toggleUnCompletedRecipient' />
              <i class="slp-square-o"></i>
              <span class="option-label">全部{{ _recipentTypeText('uncompleted') }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="phase-actions">
    <span class="btn text-btn btn-danger" @click='removePushEntry'>删除</span>
  </div>
</div>`,
  mounted: function() {
    return this._enableBackdropIfNeed();
  },
  computed: {
    human_time: function() {
      var _hour_text, _minute_text;
      _hour_text = this.human_hour > 0 ? `${this.human_hour}小时` : '';
      _minute_text = this.human_minute ? `${this.human_minute}分钟` : '';
      if (this.push_entry.waiting) {
        return `${_hour_text}${_minute_text} 后`;
      } else {
        return '立刻';
      }
    }
  },
  watch: {
    expanded: function() {
      return this._enableBackdropIfNeed();
    },
    human_hour: function() {
      return this.updateWaiting();
    },
    human_minute: function() {
      return this.updateWaiting();
    }
  },
  methods: {
    expand: function() {
      return this.expanded = true;
    },
    updatePushType: function(type) {
      return this.push_entry.push_type = type;
    },
    removePushEntry: function() {
      return this.$emit('removePushEntry');
    },
    toggleUnreadRecipient: function(event) {
      return this._toggleRecipient(event, 'unread');
    },
    toggleUnCompletedRecipient: function(event) {
      return this._toggleRecipient(event, 'uncompleted');
    },
    updateWaiting: function() {
      this.push_entry.waiting = this.human_minute + this.human_hour * 60;
      return this._refreshHumanTime();
    },
    _refreshHumanTime: _.debounce(function() {
      this.human_hour = parseInt(this.push_entry.waiting / 60);
      return this.human_minute = this.push_entry.waiting % 60;
    }, 1000),
    _toggleRecipient: function(event, type) {
      if (event.target.checked) {
        return this.push_entry.recipient_types.push(type);
      } else {
        return this.push_entry.recipient_types = _.without(this.push_entry.recipient_types, type);
      }
    },
    _checkRecipient: function(type) {
      return _.contains(this.push_entry.recipient_types, type);
    },
    _typeText: function(type) {
      return Skylark.Helpers.getZH_CN(`pushes.type.${type}`);
    },
    _recipentTypeText: function(type) {
      return Skylark.Helpers.getZH_CN(`pushes.recipient_types.${type}`);
    },
    _enableBackdropIfNeed: function() {
      if (!this.expanded) {
        return;
      }
      return Skylark.Helpers.App.capturedBackdrop((event) => {
        return this.expanded = false;
      }, this.$el);
    }
  }
};

export default PushPackageGenerator = Vue.extend({
  props: {
    customClass: {
      type: String,
      default: ''
    }
  },
  components: {
    'push-entry': push_entry_comp
  },
  data: function() {
    return {
      push_package: {
        name: '自定义推送包',
        payload: [],
        periodic: false
      }
    };
  },
  template: `<div class="push-package-generator" :class='customClass'>
  <div class="push-form-header">
    <input type="text" placeholder='请输入推送包名字' v-model.trim='push_package.name' />
  </div>
  <div class="push-form-body">
    <p>推送步骤:</p>
    <div class="phases push-list">
      <push-entry v-for='(payload, index) in push_package.payload'
                  :index='index + 1'
                  :key='payload._uid'
                  :push='payload'
                  :periodic='push_package.periodic'
                  @removePushEntry='removePayload(index)' />
      <div class="phase-item push-item">
        <div class="phase-header">
          <div class="phase-indexer circle-index"
               @click='addPayload'>
            <i class="slp-plus"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="push-form-footer justify-between">
    <div class="left">
      <label class="option-item">
        <input type="checkbox"
               :checked='push_package.periodic'
               hidden='true'
               @change='updatePeriodicSetting' />
        <i class="slp-square-o"></i>
        <span class="option-label">最后一步周期推送</span>
      </label>
    </div>
    <div class="right">
      <button class="btn-large btn-default outlined" @click='cancelCreate'>取消</button>
      <button class="btn-large btn-info" @click='createPushPackage'>创建</button>
    </div>
  </div>
</div>`,
  created: function() {
    return this.addPayload();
  },
  methods: {
    cancelCreate: function() {
      return this.$emit('cancelClicked');
    },
    createPushPackage: function() {
      return Skylark.Libs.Ajax.post("/admin/push_packages", {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          push_package: this.push_package
        },
        success: (push_package) => {
          return this.$emit('afterCreated', push_package);
        }
      });
    },
    addPayload: function() {
      return this.push_package.payload.push({
        push_type: 'Push::CustomMessage',
        // waiting unit: minutes
        waiting: 60,
        // unread | uncompleted
        recipient_types: ['unread'],
        _uid: Skylark.Helpers.Utilities.uuid()
      });
    },
    removePayload: function(index) {
      return this.push_package.payload.splice(index, 1);
    },
    updatePeriodicSetting: function(event) {
      return this.push_package.periodic = event.target.checked;
    }
  }
});
